//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  StreamsDrawerStreamType,
  StreamsLaunchContext,
} from '@streams-drawer/streams-drawer-constants';
import SparklesColor from '@images/sparkles-color.svg';
import collectionsSidebarFiltersTemplate from '@legacy-components/content/collections-sidebar-filters.html';

import _ from "js/underscore-mixins";

(function () {
  angular.module('curalate').component('collectionsSidebarFilters', {
    bindings: {
      initialFilterState: '<',
      lockedKeys: '<',
      excludedSummaryKeys: '<',
      collectionId: '<',
      launchContext: '<?',
      selectedStreamType: '<?',
    },
    template: collectionsSidebarFiltersTemplate,
    controller: [
      'CollectionFiltersConverter',
      'CONTENT',
      'cuDateLiteService',
      'SessionVarsService',
      'SEARCH_FILTERS',
      function (
        CollectionFiltersConverter,
        CONTENT,
        cuDateLiteService,
        SessionVarsService,
        SEARCH_FILTERS,
      ) {
        const self = this;

        this.selected = false;
        this.filterSetName = SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS;
        this.productTagsDropdownOptions = [
          { value: null, label: 'Not specified' },
          { value: 'true', label: 'Has product tags' },
          { value: 'false', label: "Doesn't have product tags" },
        ];
        this.filterState = {
          distribution: [],
          hasProducts: [],
          rightsStatuses: [],
          mediaItemTypes: [],
          orientation: [],
          labels: [],
          socialFilters: [],
          dateRange: [],
          platforms: [],
        };
        this.loading = true;
        this.initiallyExpandSummary = false;
        this.initiallyExpandBottomFiveFilters = false;
        this.DATA_RETENTION_DAYS = 90;
        this.sparklesImageUrl = SparklesColor;

        this.isShareV2VendorClient = SessionVarsService.isShareV2VendorClient();
        this.isAssetFeedsStreamDrawer =
          this.launchContext === StreamsLaunchContext.ASSET_FEEDS;
        this.isSemanticTagSearchEnabled = SessionVarsService.isFeatureEnabled(
          'augment_semantic_tags',
        );

        if (this.isAssetFeedsStreamDrawer) {
          this.lockedKeys = ['rightsStatuses', 'mediaItemTypes'];
        }

        this.dateRangeAliases = [
          cuDateLiteService.ALIASES.last24Hours,
          cuDateLiteService.ALIASES.last7Days,
          cuDateLiteService.ALIASES.last30Days,
          cuDateLiteService.ALIASES.last3Months,
          cuDateLiteService.ALIASES.allTime,
          cuDateLiteService.ALIASES.custom,
        ];

        this.extractDateFilterValue = function (filter) {
          return CollectionFiltersConverter.parseDatePickerFilterObject(filter);
        };

        this.$onInit = function () {
          const initialState = self.initialFilterState;
          const defaultFilters = {};

          const effectiveFilters = _(initialState).isEmpty()
            ? defaultFilters
            : initialState;

          if (!_(effectiveFilters).isEmpty()) {
            _(effectiveFilters).each((value, key) => {
              if (_(CONTENT.SUPPORTED_LIBRARY_FILTERS).contains(key)) {
                self.filterState[key] = value;
              }
            });

            const filterSummaryKeys = _(effectiveFilters).omit(
              self.excludedSummaryKeys,
            );
            const isFilterApplied = Object.values(filterSummaryKeys).some(
              (value) => value.length !== 0,
            );

            if (isFilterApplied) {
              self.initiallyExpandSummary = true;
            }
          }
          self.loading = false;
        };
      },
    ],
  });
})();
